import { Products } from './ids';
import {
  Product,
  ProductInterval,
  ProductName,
  ProductShortName,
  PremiumFeature,
  ProductFamily,
} from '../types';
import {
  businessClassFeaturesVersion2,
  businessClassFeaturesVersion3,
  businessClassFeaturesVersion3x3,
} from '../features';

export const organizationProducts: Product[] = [
  {
    id: Products.Organization.BusinessClass.v2.monthly,
    shortName: ProductShortName.BusinessClassMonthly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Monthly,
    family: ProductFamily.BusinessClass,
    price: 5,
    features: businessClassFeaturesVersion2,
    prebill: true,
    perUser: true,
    smartBill: false,
    upgrade: true,
    current: false,
    yearlyEquivalent: Products.Organization.BusinessClass.v2.yearly,
    updateProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
  {
    id: Products.Organization.BusinessClass.v2.yearly,
    shortName: ProductShortName.BusinessClassYearly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 45,
    features: businessClassFeaturesVersion2,
    prebill: true,
    smartBill: false,
    perUser: true,
    upgrade: true,
    current: false,
    updateProduct: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.BusinessClass.v3.monthly,
    shortName: ProductShortName.BusinessClass3Monthly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Monthly,
    family: ProductFamily.BusinessClass,
    price: 10,
    features: businessClassFeaturesVersion3,
    prebill: true,
    perUser: true,
    smartBill: true,
    current: false,
    yearlyEquivalent: Products.Organization.BusinessClass.v3.yearly,
    updateProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
  {
    id: Products.Organization.BusinessClass.v3.yearly,
    shortName: ProductShortName.BusinessClass3Yearly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 100,
    features: businessClassFeaturesVersion3,
    prebill: true,
    perUser: true,
    smartBill: true,
    current: false,
    updateProduct: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.BusinessClass.v3_1.monthly,
    shortName: ProductShortName.BusinessClass3x1Monthly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Monthly,
    family: ProductFamily.BusinessClass,
    price: 12.5,
    features: businessClassFeaturesVersion3,
    prebill: true,
    perUser: true,
    smartBill: true,
    current: false,
    yearlyEquivalent: Products.Organization.BusinessClass.v3_1.yearly,
    updateProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
  {
    id: Products.Organization.BusinessClass.v3_1.yearly,
    shortName: ProductShortName.BusinessClass3x1Yearly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 119.99,
    features: businessClassFeaturesVersion3,
    prebill: true,
    perUser: true,
    smartBill: true,
    current: false,
    updateProduct: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.BusinessClass.v3_3.monthly,
    shortName: ProductShortName.BusinessClass3x3Monthly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Monthly,
    family: ProductFamily.BusinessClass,
    price: 12.5,
    features: businessClassFeaturesVersion3x3,
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    yearlyEquivalent: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.BusinessClass.v3_3.yearly,
    shortName: ProductShortName.BusinessClass3x3Yearly,
    name: ProductName.BusinessClass,
    interval: ProductInterval.Yearly,
    family: ProductFamily.BusinessClass,
    price: 119.99,
    features: businessClassFeaturesVersion3x3,
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
  },
  {
    id: Products.Organization.Standard.v1a.monthly,
    shortName: ProductShortName.StandardMonthly,
    name: ProductName.Standard,
    interval: ProductInterval.Monthly,
    family: ProductFamily.Standard,
    price: 7.5,
    features: new Set<PremiumFeature>(), // TBD
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    yearlyEquivalent: Products.Organization.Standard.v1a.yearly,
    bcUpgradeProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
  {
    id: Products.Organization.Standard.v1.yearly,
    shortName: ProductShortName.StandardYearly,
    name: ProductName.Standard,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Standard,
    price: 60,
    features: new Set<PremiumFeature>(), // TBD
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    bcUpgradeProduct: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.Standard.v1b.monthly,
    shortName: ProductShortName.StandardMonthly2,
    name: ProductName.Standard,
    interval: ProductInterval.Monthly,
    family: ProductFamily.Standard,
    price: 9.5,
    features: new Set<PremiumFeature>(), // TBD
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    yearlyEquivalent: Products.Organization.Standard.v1b.yearly,
    bcUpgradeProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
  {
    id: Products.Organization.Standard.v1b.yearly,
    shortName: ProductShortName.StandardYearly2,
    name: ProductName.Standard,
    interval: ProductInterval.Yearly,
    family: ProductFamily.Standard,
    price: 84,
    features: new Set<PremiumFeature>(), // TBD
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    bcUpgradeProduct: Products.Organization.BusinessClass.v3_3.yearly,
  },
  {
    id: Products.Organization.Standard.v1.monthly,
    shortName: ProductShortName.StandardMonthly2,
    name: ProductName.Standard,
    interval: ProductInterval.Monthly,
    family: ProductFamily.Standard,
    price: 6,
    features: new Set<PremiumFeature>(), // TBD
    prebill: true,
    perUser: true,
    smartBill: false,
    current: true,
    yearlyEquivalent: Products.Organization.Standard.v1.yearly,
    bcUpgradeProduct: Products.Organization.BusinessClass.v3_3.monthly,
  },
];
